/**
 * Client-side mirror of the API's CMS validation caps
 * (`saas/apps/api/src/cms/cms.service.ts` — exported there for exactly this
 * purpose). There's no shared package between web/api yet, so these are
 * hand-kept in sync; if the API caps change, update both files together.
 *
 * Used for the editor's `maxLength` attributes and its list-size guard so a
 * Save can't round-trip to a 400 for a cap the editor could have enforced
 * (and shown inline) before ever hitting the network.
 */
export const CMS_MAX_FIELD_LENGTH = 2000;
export const CMS_MAX_LIST_ITEMS = 24;
export const CMS_MAX_ITEM_ARRAY_ENTRIES = 30;
export const CMS_MAX_ITEM_ARRAY_ENTRY_LENGTH = 1000;

/**
 * The module names a package can grant, in the canonical order the catalogue renders them.
 *
 * Hand-kept mirror of `ALL_MODULES` in `saas/apps/api/src/catalog/catalog.formatters.ts`
 * (same arrangement as the CMS caps above — there is no shared package between web and api
 * yet). If the API list changes, change this one in the same commit: a name that does not
 * round-trip through `condModules` renders as an unrecognised module rather than failing
 * loudly.
 */
export const ALL_MODULE_NAMES = ['CRM', 'Essentials', 'Manufacturing', 'RMA', 'Service', 'Accounts', 'E-commerce'];

/**
 * The absolute MAP floor no reseller price may go below, whatever their tier (Decision #20).
 * MINOR units, mirroring `GLOBAL_FLOOR_MONTHLY_MINOR` / `GLOBAL_FLOOR_YEARLY_MINOR` in
 * `saas/apps/api/src/reseller/reseller.controller.ts`.
 *
 * The mock helper these replace stored the same idea as ৳200 (major units) and then compared
 * it with `Math.max` against tier floors held in MINOR units — so the global floor was always
 * the smaller number and never actually applied. Keep these in minor.
 */
export const GLOBAL_ABSOLUTE_FLOOR_MONTHLY_MINOR = 20000;  // ৳200 / month
export const GLOBAL_ABSOLUTE_FLOOR_YEARLY_MINOR = 200000;  // ৳2,000 / year
